import { io } from 'socket.io-client';

const URL = (process.env.REACT_APP_API_URL || '').replace('https://', 'wss://');

export const socket = io(URL, {
  autoConnect: false,
  transports: ['websocket'],
});

// socket navbar
export const navbarSocket = io(URL, {
  autoConnect: false,
  transports: ['websocket'],
});
